{
  "previous": "Wstecz",
  "next": "Dalej",
  "complete": "Zakończ",
  "verifyAndCheckIn": "Zweryfikuj i zamelduj się",
  "loading": {
    "retrievingLocation": "Pobieranie lokalizacji...",
    "retrievingWarehouse": "Pobieranie danych magazynu..."
  },
  "validation": {
    "fieldRequired": "To pole jest wymagane",
    "fieldRequiredWithLabel": "{label} jest wymagane",
    "phoneInvalid": "To nie jest prawidłowy numer telefonu",
    "phoneInvalidWithExample": "To nie jest prawidłowy numer telefonu (przykład: {example})"
  }
}
